import { render } from "./FormRecordDescription.vue?vue&type=template&id=5c3a80ef&scoped=true"
import script from "./FormRecordDescription.vue?vue&type=script&lang=js"
export * from "./FormRecordDescription.vue?vue&type=script&lang=js"

import "./FormRecordDescription.vue?vue&type=style&index=0&id=5c3a80ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3a80ef"]])

export default __exports__